export const COMMUNITY_ID = "communityId";
export const SELECTION_CRITERIA = "selectionCriteria";
export const DATE_RANGE = "dateRange";
export const YEAR = "year";
export const OWNER = "ownershipIds";
export const CLEARING_STATUS = "paidStatus";
export const GL_MASTER_IDS = "glMasterIds";

export const LEDGER = "LEDGER";
export const COST_ANALYTICS = "COST_ANALYTICS";
export const OWNER_OPTION = "Owner";
export const VENDOR_OPTION = "Vendor";
export const MONTHLY = "monthly";
export const YEARLY = "yearly";

export const selectionCriteriaOptions = [
  { value: MONTHLY, label: "Monthly" },
  { value: YEARLY, label: "Yearly" },
];

export const lineItemColumnOptions = [
  { key: "postingDate", label: "Posting Date", checked: true },
  { key: "documentDate", label: "Document Date", checked: true },
  { key: "postDocumentHeaderId", label: "Document No", checked: true },
  { key: "lineNumber", label: "Line item id", checked: true },
  { key: "documentType", label: "Doc Type", checked: true },
  { key: "itemText", label: "Line item text", checked: true },
  { key: "itemText", label: "Property Ownership ID", checked: true },
  { key: "clearingIndicator", label: "Clearing Indicator", checked: false },
  { key: "clearingId", label: "Clearing Doc No", checked: false },
  { key: "clearingDate", label: "Clearing Document Date", checked: false },
  { key: "baselineDate", label: "Baseline Date", checked: false },
  { key: "paymentTerms", label: "Payment Terms", checked: false },
  { key: "dueDate", label: "Due Date", checked: false },
  { key: "paymentMethod", label: "Payment Method", checked: false },
  { key: "paymentDetails", label: "Payment Details", checked: false },
  { key: "billingCategory", label: "Billing Category", checked: true },
  { key: "transactionType", label: "Transaction Type", checked: true },
  { key: "frequency", label: "Frequency", checked: false },
  { key: "billingDate", label: "Billing Date", checked: false },
  { key: "debitAmount", label: "Debits", checked: false },
  { key: "creditAmount", label: "Credits", checked: false },
];
